import { MetadataFieldDTO } from "../DTO/metadataFieldDTO";

export class MetadataField{
    public index!: number;
    public name!: string;

    public static mapFromDTO(param:MetadataFieldDTO):MetadataField{ 
        if (!param) throw new Error("parameter is null")
        let obj = new MetadataField();
        try
        {
            obj.name = param.name;
            obj.index = param.index;
        }
        catch(e)
        {
            console.log(e);
            
        }
        return obj;
    }

    public static mapToDTO(param:MetadataField):MetadataFieldDTO{ 
        if (!param) throw new Error("parameter is null")
        let dto = new MetadataFieldDTO();
        try
        {
            dto.name = param.name;
            dto.index = param.index;
        }
        catch(e)
        {
            console.log(e);
            
        }
        return dto;
    }

    get clone(){
        let clone_mdf=new MetadataField();
        clone_mdf.name=this.name;
        clone_mdf.index=this.index;
        return clone_mdf;
    }
}